import { render, staticRenderFns } from "./DownloadAllReception.vue?vue&type=template&id=6f107ba8"
import script from "./DownloadAllReception.vue?vue&type=script&lang=js"
export * from "./DownloadAllReception.vue?vue&type=script&lang=js"
import style0 from "./DownloadAllReception.vue?vue&type=style&index=0&id=6f107ba8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports